import { createAction } from 'redux-actions';
import * as actionTypes from './constants';

export const fetchWipCodes = createAction(actionTypes.FETCH_WIP_CODES_REQUEST);
export const fetchWipCodesSuccess = createAction(actionTypes.FETCH_WIP_CODES_SUCCESS);
export const fetchWipCodesFailure = createAction(actionTypes.FETCH_WIP_CODES_FAILURE);

export const fetchWipCode = createAction(actionTypes.FETCH_WIP_CODE_REQUEST);
export const fetchWipCodeSuccess = createAction(actionTypes.FETCH_WIP_CODE_SUCCESS);
export const fetchWipCodeFailure = createAction(actionTypes.FETCH_WIP_CODE_FAILURE);

export const addWipCode = createAction(actionTypes.ADD_WIP_CODE_REQUEST);
export const addWipCodeSuccess = createAction(actionTypes.ADD_WIP_CODE_SUCCESS);
export const addWipCodeFailure = createAction(actionTypes.ADD_WIP_CODE_FAILURE);

export const updateWipCode = createAction(actionTypes.UPDATE_WIP_CODE_REQUEST);
export const updateWipCodeSuccess = createAction(actionTypes.UPDATE_WIP_CODE_SUCCESS);
export const updateWipCodeFailure = createAction(actionTypes.UPDATE_WIP_CODE_FAILURE);

export const deleteWipCode = createAction(actionTypes.DELETE_WIP_CODE_REQUEST);
export const deleteWipCodeSuccess = createAction(actionTypes.DELETE_WIP_CODE_SUCCESS);
export const deleteWipCodeFailure = createAction(actionTypes.DELETE_WIP_CODE_FAILURE);

export const fetchWipCodesForScope = createAction(actionTypes.FETCH_WIP_CODES_SCOPE_REQUEST);
export const fetchWipCodesForScopeSuccess = createAction(actionTypes.FETCH_WIP_CODES_SCOPE_SUCCESS);
export const fetchWipCodesForScopeFailure = createAction(actionTypes.FETCH_WIP_CODES_SCOPE_FAILURE);

export const fetchWipCodesForOrder = createAction(actionTypes.FETCH_WIP_CODES_ORDER_REQUEST);
export const fetchWipCodesForOrderSuccess = createAction(actionTypes.FETCH_WIP_CODES_ORDER_SUCCESS);
export const fetchWipCodesForOrderFailure = createAction(actionTypes.FETCH_WIP_CODES_ORDER_FAILURE);

export const saveWipCodesOnOrder = createAction(actionTypes.SAVE_WIP_CODES_ORDER_REQUEST);
export const saveWipCodesOnOrderSuccess = createAction(actionTypes.SAVE_WIP_CODES_ORDER_SUCCESS);
export const saveWipCodesOnOrderFailure = createAction(actionTypes.SAVE_WIP_CODES_ORDER_FAILURE);

